import { FilePreviewProps } from 'screens/blaze/Home/components/Catalogue/components/FilePreview/Types'
import { PreviewUnavailable } from 'screens/blaze/Home/components/Catalogue/components/FilePreview/PreviewUnavailable'
import { EmptyDesign } from 'screens/blaze/Home/components/Catalogue/components/FilePreview/EmptyDesign'
import Styles from './DesignPreview.module.scss'
import cx from 'classnames'
import { getAspectRatio } from 'utils/aspectRatio'

export const DesignPreview = ({ file, className, emptyClassName }: FilePreviewProps) => {
  const { title, preview_url, width, height } = file

  const aspectRatio = getAspectRatio(width, height)

  if (file.is_blank) {
    return <EmptyDesign />
  }

  if (!preview_url) {
    return <PreviewUnavailable className={emptyClassName} />
  }

  return (
    <div className={cx(Styles.preview, className, Styles[aspectRatio])}>
      <img src={file.preview_url} alt={title} className={Styles.image} />
    </div>
  )
}
